import React from 'react';
import { useTranslation } from 'react-i18next';

export default function Loading() {
	const { t } = useTranslation();

	return (
		<div
			className="d-flex flex-column justify-content-center align-items-center t-0"
			style={{ height: '100vh' }}>
			<div className="spinner-grow my-auto" role="status" />
			<div>
				<strong> {t('The page is loading')}</strong>
			</div>
			<div className="text-center px-2">
				{t(
					'Please contact support or refresh is this page does not redirect in 1 minute'
				)}
			</div>
		</div>
	);
}
